export default "/wbtc-usd.ce9b41e323a60c9ecb80abe29772fa5e.svg";